import { Form, Input, Modal, notification } from 'antd';
import { filterDigits, localize } from 'mixins/helpers';
import Button from 'mixins/ui/button/button';
import React, { useState } from 'react';
import { findTaxpayerData, generatePublicApiToken } from '../actions';

const GenerateTokenModal = (props: any) => {
    const { translations } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [modalForm] = Form.useForm();

    const handleCheckTaxpayerCode = ({ target: { value } }) => {
        filterDigits(modalForm, 'taxpayerCode');
        const taxpayerCode = String(value || '').replace(/\D/g, '');

        if (taxpayerCode.length !== 12) {
            modalForm.resetFields(['name']);
            return;
        }

        modalForm.validateFields(['taxpayerCode']).then(() => {
            modalForm.resetFields(['name']);

            findTaxpayerData(taxpayerCode)
                .then((taxpayerData) => {
                    const name =
                        taxpayerData.data?.name?.replace(/\s*\/\s*null$/, '') || '';

                    modalForm.setFieldsValue({ name });
                })
                .catch(() => {
                    notification.error({
                        message: localize('error', translations),
                        description: localize('reg.invalid-iin', translations),
                    });
                });
        });
    };

    const createToken = () => {
        modalForm.validateFields().then(() => {
            setIsLoading(true);

            const formValues = modalForm.getFieldsValue();

            generatePublicApiToken(formValues)
                .then(() => {
                    notification.success({
                        message: localize(
                            'stats-external-uploaded-successfully',
                            translations
                        ),
                    });
                    props.handleOk();
                    modalForm.resetFields();
                })
                .finally(() => {
                    setIsLoading(false);
                });
        });
    };

    const close = () => {
        modalForm.resetFields();
        props.handleCancel();
    };

    return (
        <Modal
            title={localize('banner-create-title', translations)}
            visible={props.isModalOpen}
            onCancel={close}
            footer={[
                <Button key="cancel" onClick={close}>
                    {localize('cancel', translations)}
                </Button>,
                <Button
                    key="create"
                    onClick={createToken}
                    loading={isLoading}
                >
                    {localize('create', translations)}
                </Button>,
            ]}
        >
            <Form name="basic" layout="vertical" form={modalForm}>
                <Form.Item
                    label={localize('iin-bin', translations)}
                    name="taxpayerCode"
                    rules={[
                        {
                            required: true,
                            message: localize(
                                'error.field-is-required',
                                translations
                            ),
                        },
                        {
                            len: 12,
                            message: localize(
                                'error.iin-length-12',
                                translations
                            ),
                        },
                    ]}
                >
                    <Input
                        onChange={handleCheckTaxpayerCode}
                        maxLength={12}
                        size="large"
                        placeholder={localize('placeholder.input', translations)}
                        className="input"
                    />
                </Form.Item>
                <Form.Item
                    label={localize('fio-or-org-name', translations)}
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: localize(
                                'error.field-is-required',
                                translations
                            ),
                        },
                    ]}
                >
                    <Input size="large" readOnly disabled />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default GenerateTokenModal;
